// extracted by mini-css-extract-plugin
module.exports = {"preSettle-roomRate-info":"preSettle_preSettle-roomRate-info__1h5Mh","bill-payment":"preSettle_bill-payment__P8rBG","bill-form":"preSettle_bill-form__2Ih0S"};